import { Box, Divider } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../../../stack/environment/icons/iconExport";
import WorkflowCardContent from "./WorkflowCardContent";

const WorkflowCardCustom = ({ data, onEdit }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        width: 416,
        minWidth: 416,
        height: 310,
        minHeight: 310,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: "10px",
        boxShadow: "0px 1px 4px 0px " + colors.grey_48percent,
        backgroundColor: colors.common_white,
        padding: "24px",
        gap: "16px",
      }}
    >
      <WorkflowCardContent data={data} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          width: "100%",
        }}
      >
        <Divider orientation="horizontal" flexItem />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              border: "1px solid " + colors.grey_300,
              borderRadius: "6px",
              padding: "4px",
            }}
          >
            <SvgToIcon
              IconLogo={icons.DeleteBinIcon2}
              width="16px"
              height="16px"
              style={{ color: colors.action_active }}
            />
          </Box>
          <Box
            onClick={() => onEdit?.(data)}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              border: "1px solid " + colors.grey_300,
              borderRadius: "6px",
              padding: "4px",
            }}
          >
            <SvgToIcon
              IconLogo={icons.EditIcon2}
              width="16px"
              height="16px"
              style={{ color: colors.action_active }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkflowCardCustom;
